import {useMutation} from '@tanstack/react-query'
import {sendMessage} from '../services/chat.http'
import {SendMessageRequest} from '../chat.model'
import {MUTATION_KEYS} from './keys'
import {useMe} from '@/features/authentication/queries/useMe'
import {UserRoleE} from '@/types'
import {LocalStorageManager} from '@/utilities/localStorage'

type UseSendMessageV3Options = {
    chatIdentifier?: string
    onSuccessCallback?: () => void
    onErrorCallback?: (error: Error) => void
}

export const useSendMessageV3 = ({chatIdentifier, onSuccessCallback, onErrorCallback}: UseSendMessageV3Options) => {
    const {data: user} = useMe()
    const isRepresentative = user?.type === UserRoleE.Representative
    const representedCreatorId = isRepresentative ? LocalStorageManager.chatUserId.get() : undefined
    return useMutation<{remainingDailyMessagesCount: number}, Error, SendMessageRequest>({
        mutationKey: [MUTATION_KEYS.send_message],
        mutationFn: (messagePayload: SendMessageRequest) =>
            sendMessage(messagePayload, chatIdentifier, representedCreatorId),
        onSuccess: () => {
            onSuccessCallback?.()
        },
        onError: (error: Error) => {
            onErrorCallback?.(error)
        }
    })
}
